import { render, staticRenderFns } from "./CourseEdit.vue?vue&type=template&id=4c518ac8"
import script from "./CourseEdit.vue?vue&type=script&lang=ts"
export * from "./CourseEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports